import type { CSSProperties } from 'react';
import React from 'react';

import { dggTheme } from 'src/styles/dggTheme';
import * as styles from './ButtonLink.styles';

export interface ButtonLinkProps {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  backgroundColor?: string;
  href: string;
  text: string;
  textColorMode?: 'light' | 'dark';
}

export const ButtonLink = ({
  onClick,
  backgroundColor = dggTheme.colors.parisM,
  href,
  text,
  textColorMode = 'light',
}: ButtonLinkProps) => {
  return (
    <a
      href={href}
      css={[
        styles.buttonLink,
        textColorMode === 'light' ? styles.buttonTextLight : styles.buttonTextDark,
      ]}
      style={
        {
          '--backgroundColor': backgroundColor,
        } as CSSProperties
      }
      onClick={onClick}
    >
      {text}
    </a>
  );
};
